
(function () {
    angular.module('irricrops')
      .factory('File', ['$http', 'Upload', 'global', 'urls','$timeout','$stateParams', '$mdToast', 'newCacheManager', 'CONSTANTES',
      function ($http, Upload, global, urls, $timeout, $stateParams, $mdToast,NCM, CONSTANTES) {

          var fileDownload = function(httpPath, params, prepareFn, successFn, errorFn) {
            // Use an arraybuffer
            if (prepareFn !== undefined) {
              prepareFn();
            }
            var dataHttp          = {};
            dataHttp.method       = params.method || "POST";
            dataHttp.url          = httpPath;
            dataHttp.responseType = 'arraybuffer';
            dataHttp.params       = params;
            var req               = $http(dataHttp);

            req.success( function(data, status, headers) {

                var octetStreamMime = 'application/octet-stream';
                var success = false;

                // Get the headers
                var headers = headers(); // jshint ignore:line

                // Get the filename from the x-filename header or default to "download.bin"
                var defaultName = moment().format('DD MMM YYYY');
                if (angular.isDefined(params.filename)) {
                  defaultName =params.filename;
                }

                var filename = defaultName;

                // Determine the content type from the header or default to "application/octet-stream"
                var contentType = headers['content-type'] || octetStreamMime;
                var blob = {};
                var url = "";

                try
                {
                  // Try using msSaveBlob if supported
                  console.log("Trying saveBlob method ...");
                  blob = new Blob([data], { type: contentType });
                  if(navigator.msSaveBlob)
                    navigator.msSaveBlob(blob, filename);
                  else {
                    // Try using other saveBlob implementations, if available
                    var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                    if(saveBlob === undefined) throw "Not supported";
                    saveBlob(blob, filename);
                  }
                  console.log("saveBlob succeeded");
                  success = true;
                  if (success !== undefined) {
                    successFn();
                  }
                } catch(ex)
                {
                  console.log("saveBlob method failed with the following exception:");
                  console.log(ex);
                }

                if(!success)
                {
                  // Get the blob url creator
                  var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                  if(urlCreator)
                  {
                    // Try to use a download link
                    var link = document.createElement('a');
                    if('download' in link)
                    {
                      // Try to simulate a click
                      try
                      {
                        // Prepare a blob URL
                        console.log("Trying download link method with simulated click ...");
                        blob = new Blob([data], { type: contentType });
                        url = urlCreator.createObjectURL(blob);
                        link.setAttribute('href', url);

                        // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                        link.setAttribute("download", filename);

                        // Simulate clicking the download link
                        var event = document.createEvent('MouseEvents');
                        event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                        link.dispatchEvent(event);
                        console.log("Download link method with simulated click succeeded");
                        success = true;
                        if (success !== undefined) {
                          successFn();
                        }

                      } catch(ex) {
                        console.log("Download link method with simulated click failed with the following exception:");
                        console.log(ex);
                      }
                    }

                    if(!success)
                    {
                      // Fallback to window.location method
                      try
                      {
                        // Prepare a blob URL
                        // Use application/octet-stream when using window.location to force download
                        console.log("Trying download link method with window.location ...");
                        blob = new Blob([data], { type: octetStreamMime });
                        url = urlCreator.createObjectURL(blob);
                        window.location = url;
                        console.log("Download link method with window.location succeeded");
                        success = true;
                        if (success != undefined) {
                          successFn();
                        }
                      } catch(ex) {
                        console.log("Download link method with window.location failed with the following exception:");
                        console.log(ex);
                      }
                    }

                  }
                }

                if(!success)
                {
                  // Fallback to window.open method
                  console.log("No methods worked for saving the arraybuffer, using last resort window.open");
                  window.open(httpPath, '_blank', '');
                  if (errorFn!== undefined) {
                    errorFn();
                  }
                }
              })
            .error(function(data, status) {
              console.log("Request failed with status: " + status);
              if (errorFn!== undefined) {
                errorFn();
              }
              // Optionally write the error out to scope
              // $scope.errorDetails = "Request failed with status: " + status;
            });
            return req;
          };

          /**
            * @ngdoc method
            * @name irricrops.File#fileUpload
            * @methodOf irricrops.fileFac
            *
            * @description
            * Metodo que se usa para subir archivos al servidor
            * utiliza la peticion de /vinedo/+fn
            * fn definido por parametro
            *
            * http://jsfiddle.net/danialfarid/0mz6ff9o/135/
            *
            * @param {object} file archivo a subir
            * @param {object} $invalidFiles archivo invalidos a subir
            * @param {String} fn nombre de la funcion que se concaten a la ruta
            * @param {String} fileName Nombre de la variable en la peticion http para el archivo
            * @returns {promise} file.upload
          **/

          var fileUpload = function (file, $invalidFiles, fn, fileName, dataHttp, showToast) {
            if (file === null) {
              return null;
            }
            if(showToast === undefined || showToast ===  null){
              showToast = true;
            }

            var f         = {};
            var errFile   = {};

            f[fn] = file;
            errFile[fn] = $invalidFiles && $invalidFiles[0];

            if (angular.isUndefined(fileName) || fileName === null) {
              fileName = fn;
            }

            var data = null;
            if (dataHttp !== undefined && dataHttp !== null) {
              data = dataHttp  ;
            }else{
              data = {
                vinedo_id: $stateParams.id //TODO volver esto standar cuando sea necesario
              };
            }
            data[fileName] = file;

            if (file) {
                file.upload = Upload.upload({
                    url: urls.BASE+"/"+fn,
                    data: data
                });

                file.upload.then(function (response) {
                  //timeout es un hack para refrescar $apply
                    $timeout(function () {
                        file.result = response.data;
                    });
                    if (fn.split("/").lenght > 1) {
                      NCM.action(
                        "upload."+fn.split("/")[0]+"."+fn.split("/")[1],
                        $stateParams.id,
                        global.getChildren(fn.split("/")[0], $stateParams.id),
                        0
                      );
                    }
                    if(showToast){
                      var toast = $mdToast.simple()
                          .textContent("Archivo Subido Exitosamente")
                          .position(CONSTANTES.TOAST_POSITION);
                      $mdToast.show(toast);
                    }
                }, function (response) {
                    var errorMsg = null;
                      if(showToast){
                        var toast = $mdToast.simple().textContent("No se logro subir el archivo solicitado, ERROR "+response.status)
                            .position(CONSTANTES.TOAST_POSITION);
                        $mdToast.show(toast);
                      }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
            return file.upload;
          };


        return {
          download:fileDownload,
          upload:fileUpload
        };


      }]);

})();
